export const BAD_REQUEST_STATUS_CODE = 400;
export const OK_STATUS_CODE = 200;
export const IN_ACTIVITY_TIMEOUT = 2 * 60 * 1000 // 10 Minutes
export const ADMIN_MODULES = 'Case, Account, Report';

// User data related local storage keys
export const USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY = "selected_location";
export const USER_CLINIC_LOCAL_STORAGE_KEY = "user_clinic";
export const USER_LOCALE_LOCAL_STORAGE_KEY = "user_locale";
export const USER_PROFILE_LOCAL_STORAGE_KEY = "user_profile";
export const USER_TOKEN_LOCAL_STORAGE_KEY = "user_token";
export const USER_LOCAL_STORAGE_KEY = "user";

export const ALL_LOCAL_STORAGE_USER_RELATED_KEYS = [
  USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY,
  USER_CLINIC_LOCAL_STORAGE_KEY,
  USER_LOCALE_LOCAL_STORAGE_KEY,
  USER_PROFILE_LOCAL_STORAGE_KEY,
  USER_TOKEN_LOCAL_STORAGE_KEY,
  USER_LOCAL_STORAGE_KEY
]